function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "x8");

function SvgIcnTimes8({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5.18 28.73)",
    style: {
      fill: "#5e5e5d",
      fontSize: 24,
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTimes8);
export default __webpack_public_path__ + "static/media/icn-times8.3b86a6285a7b795f1504a9fcdd63fbda.svg";
export { ForwardRef as ReactComponent };